import { z } from 'zod'

export const userProfileFormSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First name is required')
    .max(256, 'First name must be at most 256 characters'),
  lastName: z
    .string()
    .min(1, 'Last name is required')
    .max(256, 'Last name must be at most 256 characters'),
})

export type UserProfileFormSchemaType = z.infer<typeof userProfileFormSchema>
